import { createTheme } from "@mui/material";
const primaryColor = "#009A5A";
const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
  },
  typography: {
    // fontFamily: "Montserrat",
    // button: {
    //   textTransform: "none",
    //   fontSize: 15,
    //   borderRadius: 25,
    // },
  },
  /* components: {
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
              font-family: "Montserrat";
              src: local("Montserrat"),
                url(./Fonts/montserrat_regular.otf) format("opentype");
            }
          `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 100,
          fontSize: 16,
        },
      },
    },
  }, */
});

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export { theme, ModalStyle, primaryColor };
